import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconMarkerTrack = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <g filter="url(#filter0_d_5677_177286)">
        <path
          d="M10.0624 2.70711C10.4529 2.31658 11.0861 2.31658 11.4766 2.70711L17.8329 9.0634C18.4629 9.69337 18.0167 10.7705 17.1258 10.7705L10.7695 10.7705L4.41324 10.7705C3.52233 10.7705 3.07617 9.69337 3.70613 9.0634L10.0624 2.70711Z"
          fill="#02020A"
        />
        <path
          d="M11.1231 3.06066L17.4794 9.41703C17.7746 9.71232 17.597 10.204 17.2067 10.2643L17.1259 10.2705L10.7695 10.2698L4.41317 10.2705C3.96779 10.2705 3.74475 9.732 4.05961 9.41703L10.416 3.06066C10.6112 2.8654 10.9278 2.8654 11.1231 3.06066Z"
          stroke="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5677_177286"
          x="0.410156"
          y="0.414062"
          width="20.7188"
          height="14.3564"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5677_177286" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5677_177286"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export const IconMarkerTrack = forwardRef(_IconMarkerTrack)
